import { createSlice } from "@reduxjs/toolkit";

export const teacherSlice = createSlice({
  name: "teacher",
  initialState: { teacher: null },
  reducers: {
    setTeacher: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setTeacher } = teacherSlice.actions;
export const selectTeacher = (state) => state.teacher.value;

export default teacherSlice.reducer;
